<template>
    <div>
        <div class="columns">
            <div class="column">
                <h1 class="is-size-2 is-page-title">Over ons</h1>
                <p>
                    De hoofdtaak van de vzw is het heropbouwen van het hondenras 'De Belgische Mastiff'. Dit fokprogramma gebeurt in nauwe samenwerking met
                    de Koninklijke Maatschappij Sint-Hubertus (KMSH) en de wetenschappelijke commissie van de Koninklijke Kynologische Unie Sint-Hubertus (KKUSH).
                    Hierdoor wordt er steeds in overleg met deze verschillende organisaties goed nagedacht over elke stap in het fokproces om zo het ras op de best mogelijke
                    manier vooruit te helpen.                    
                </p>
                <br />
                <p>
                    Daarnaast is het voor ons ook enorm belangrijk om mogelijke toekomstige  eigenaars wegwijs te maken in het opvoeden en houden van een Belgische Mastiff.
                    We willen de hond namelijk alle kansen geven om te kunnen uitgroeien tot een trouwe gezinshond.
                </p>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
          <router-link to="/over" class="is-page-read-more">Lees meer</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>
    .is-page-read-more {
        margin-bottom: 4vh;
    }
</style>